export default __webpack_public_path__ + "static/media/musto_bg.91599a51.png";